class ScentIntensityCard extends HTMLElement {
  #timer = null;
  #mql = window.matchMedia('(min-width: 990px)');

  connectedCallback() {
    this.#mql.addEventListener('change', this.#onBreakpoint);
    this.#setup();
  }

  disconnectedCallback() {
    this.#mql.removeEventListener('change', this.#onBreakpoint);
    this.#stopCycle();
    const scale = this.querySelector('.humble-scent-intensity__list');
    if (scale) scale.removeEventListener('mouseleave', this.#onLeave);
    for (const btn of this.querySelectorAll('.humble-scent-intensity__item-btn')) {
      btn.removeEventListener('mouseenter', this.#onEnter);
    }
  }

  #onBreakpoint = () => {
    this.#stopCycle();
    this.#setup();
  };

  #setup() {
    const scale = this.querySelector('.humble-scent-intensity__list');
    if (!scale) return;

    const btns = this.querySelectorAll('.humble-scent-intensity__item-btn[data-intensity]');

    if (this.#mql.matches) {
      this.#stopCycle();
      this.#activateFirst();
      for (const btn of btns) btn.addEventListener('mouseenter', this.#onEnter);
      scale.addEventListener('mouseleave', this.#onLeave);
    } else {
      for (const btn of btns) btn.removeEventListener('mouseenter', this.#onEnter);
      scale.removeEventListener('mouseleave', this.#onLeave);
      this.#startCycle();
    }
  }

  #onEnter = (event) => {
    this.#activate(event.currentTarget);
  };

  #onLeave = () => {
    this.#activateFirst();
  };

  #activateFirst() {
    const first = this.querySelector('.humble-scent-intensity__item-btn[data-intensity]');
    if (first) this.#activate(first);
  }

  #startCycle() {
    const btns = [...this.querySelectorAll('.humble-scent-intensity__item-btn[data-intensity]')];
    if (!btns.length) return;
    let i = 0;
    this.#activate(btns[i]);
    this.#timer = setInterval(() => {
      i = (i + 1) % btns.length;
      this.#activate(btns[i]);
    }, 2500);
  }

  #stopCycle() {
    if (this.#timer) {
      clearInterval(this.#timer);
      this.#timer = null;
    }
  }

  #activate(btn) {
    const { intensity } = btn.dataset;

    for (const b of this.querySelectorAll('.humble-scent-intensity__item-btn')) {
      const active = b === btn;
      b.classList.toggle('is-active', active);
      b.setAttribute('aria-pressed', String(active));
    }

    for (const frame of this.querySelectorAll('.humble-scent-intensity__art-frame')) {
      frame.classList.toggle('is-active', frame.dataset.intensity === intensity);
    }
  }
}

customElements.define('scent-intensity-card', ScentIntensityCard);
